import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme, buttonBaseClasses } from '@mui/material';
import { baseTheme } from '../base-theme';
import { generateFocusRingStyles } from './utils/focus';

const focusRingStyles = generateFocusRingStyles(buttonBaseClasses.focusVisible, {
    outlineOffset: `-${baseTheme.tokens.borderWidth.md}`,
});

export const MuiTabs: {
    defaultProps?: ComponentsProps['MuiTabs'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTabs'];
    variants?: ComponentsVariants['MuiTabs'];
} = {
    defaultProps: {
        textColor: 'secondary',
        indicatorColor: 'primary',
    },
    styleOverrides: {
        indicator: (props) => ({
            height: props.theme.tokens.borderWidth.lg,
        }),
        flexContainer: (props) => ({
            borderBottom: `${props.theme.tokens.borderWidth.sm} solid ${props.theme.palette.divider}`,
        }),
    },
    variants: [],
};

export const MuiTab: {
    defaultProps?: ComponentsProps['MuiTab'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTab'];
    variants?: ComponentsVariants['MuiTab'];
} = {
    defaultProps: {},
    styleOverrides: {
        root: (props) => {
            return [
                props.theme.typography.tab,
                {
                    padding: `${baseTheme.tokens.spacing.xs} ${baseTheme.tokens.spacing.md}`,
                    [`&:hover`]: {
                        color: baseTheme.palette.text.primary,
                    },
                },
                focusRingStyles,
            ];
        },
    },
    variants: [],
};
